import { useEffect, useState } from "react";
import { handlePagingAll } from "../../../../components/api/APIUtilities";
import ListResponsive from "../../../../components/other/ListResponsive";
import { BCPSquarePlus } from "../../../../components/icons/bcp/BCPIcons";
import OrganizationCard from "../../../../components/layout/OrganizationCard";
import { Box, Grid, Typography } from "@mui/material";
import { isAppMode } from "../../../../global/AppOverlay";
import { getLanguageCookie } from "../../../../language/LanguageFunctions";
import { useTranslation } from "react-i18next";

export default function OrganizationsTab(props) {
  const { authContext } = props;
  const [subLoading, setSubLoading] = useState(true);
  const [gameStores, setGameStores] = useState(null);

  // Language setup
  const language = getLanguageCookie();
  const { t } = useTranslation("translation", {
    lng: language,
    keyPrefix: "pages.account.organizations"
  });

  const appMode = isAppMode();

  useEffect(() => {
    const check = async () => {
      var apiGameStores = await handlePagingAll(`/gamestores`, {
        myStores: true,
        sortAscending: false,
        "expand[]": ["location", "owner", "gameStore", "user"]
      });

      apiGameStores.forEach((apiGameStore) => {
        if (apiGameStore.location) {
          apiGameStore.location.displayLocation = "";
          if (apiGameStore.location.city && apiGameStore.location.city !== "") {
            if (apiGameStore.location.displayLocation !== "") {
              apiGameStore.location.displayLocation += ", ";
            }
            apiGameStore.location.displayLocation += apiGameStore.location.city;
          }
          if (
            apiGameStore.location.state &&
            apiGameStore.location.state !== ""
          ) {
            if (apiGameStore.location.displayLocation !== "") {
              apiGameStore.location.displayLocation += ", ";
            }
            apiGameStore.location.displayLocation +=
              apiGameStore.location.state;
          }
          if (
            apiGameStore.location.country &&
            apiGameStore.location.country !== ""
          ) {
            if (apiGameStore.location.displayLocation !== "") {
              apiGameStore.location.displayLocation += ", ";
            }
            apiGameStore.location.displayLocation +=
              apiGameStore.location.country;
          }
        }
      });
      setGameStores(apiGameStores);
      setSubLoading(false);
    };
    check();
  }, []);

  return (
    <Box sx={{ width: "100%" }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h4" fontWeight="700">
            {t("organizations", {
              defaultValue: "Organizations"
            })}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <ListResponsive
            originalList={subLoading ? null : gameStores}
            doSearch
            doPages
            initialRowsPerPage={24}
            actionButton={{
              props: {
                variant: "contained",
                color: "primary",
                fullWidth: true,
                href: "/organize/organization",
                target: `${appMode ? "_blank" : "_self"}`,
                startIcon: <BCPSquarePlus />
              },
              label: t("newOrganization", {
                defaultValue: "New Organization",
                keyPrefix: "buttons"
              })
            }}
            searchProps={{
              label: t("searchOrganizations", {
                defaultValue: "Search Organizations"
              }),
              performSearch: (originalList, searchText) => {
                if (!searchText || searchText === "") {
                  return originalList;
                } else {
                  var filteredList = originalList.filter(function (el) {
                    if (el?.name?.toLowerCase().includes(searchText))
                      return true;
                    if (
                      el?.owner?.firstName?.toLowerCase().includes(searchText)
                    )
                      return true;
                    if (el?.owner?.lastName?.toLowerCase().includes(searchText))
                      return true;
                    if (
                      el?.location?.displayLocation
                        ?.toLowerCase()
                        .includes(searchText)
                    )
                      return true;

                    return false;
                  });
                  return filteredList;
                }
              }
            }}
            rowProps={{
              mapFunction: (row, index) => (
                <Grid
                  key={row?.id || index}
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  sx={{ p: 1 }}
                >
                  <OrganizationCard
                    organize
                    organization={row}
                    authContext={authContext}
                    key={row?.id || index}
                  />
                </Grid>
              )
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
